import { render, staticRenderFns } from "./ViewTheatreDetails.vue?vue&type=template&id=622b6146&"
import script from "./ViewTheatreDetails.vue?vue&type=script&lang=js&"
export * from "./ViewTheatreDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports